module.exports = __webpack_public_path__ + "media/HapticInterface_Program.6c3c0457.mp4";